import { CREATE_BOOKING_TYPE, CreateBookingType } from "../../config/params";
import { actionTypes } from "./booking-appointment-type.actions";

export interface IBookingAppointmentType{
    bookingAppointmentType: CreateBookingType;
    appointmentTypeIndicator: Number;
    isDropoffAvailable: boolean;
    isServiceStatusUpdated: boolean;
};

const initialState: IBookingAppointmentType = {
  bookingAppointmentType: CREATE_BOOKING_TYPE.NORMAL_BOOKING,
  appointmentTypeIndicator: 1,
  isDropoffAvailable: true,
  isServiceStatusUpdated: false,
};

export const bookingAppointmentTypeReducer = (
  state: IBookingAppointmentType = initialState,
  action: { type: string, payload: any},
) => {
  switch (action.type) {
  case actionTypes.SET_BOOKING_APPOINTMENT_TYPE:
    return {
      ...state,
      bookingAppointmentType: action.payload,
    };
  case actionTypes.SET_APPOINTMENT_TYPE_INDICATOR:
    return {
      ...state,
      appointmentTypeIndicator: action.payload,
    };
  case actionTypes.SET_IS_DROPOFF_AVAILABLE:
    return {
      ...state,
      isDropoffAvailable: action.payload,
    };
  case actionTypes.SET_IS_SERVICE_STATUS_UPDATED:
    return {
      ...state,
      isServiceStatusUpdated: action.payload,
    };
  case actionTypes.SET_DEFAULT_BOOKING_TYPE:
    return {
      ...state,
      bookingAppointmentType: initialState.bookingAppointmentType,
      appointmentTypeIndicator: initialState.appointmentTypeIndicator,
    };
  default:
    return state;
  }
};
